import React, { useState } from 'react';
import cx from 'classnames';
import styles from './SharingModal.module.scss';
import ModalHeader from '../../Modal/ModalHeader';
import Tab from './Tab';
import ShareVia from './ShareVia/ShareVia';
import Embed from './Embed/Embed';
import { Icon } from '../../Icon';
import { useTranslation } from 'react-i18next';
import useAccessibleFocus from '../../../../common/hooks/useAccessibleFocus';

function SharingModalContent({ onClose, videoId, anonThumbnailUrl, videoPassword, isSkipAuthToken = false }) {
  const [tabIndex, setTabIndex] = useState(2);

  const { t } = useTranslation();

  const ref = useAccessibleFocus()

  return (
    <div>
      <ModalHeader className={cx(styles.header)}>
        <div className={styles.tabsContainer}>
          <Tab className={cx(styles.tab, [tabIndex === 1 && styles.selectedTab])} onClick={() => setTabIndex(1)}>
            <span>{t('video.settings.share.share_via')}</span>
          </Tab>
          <Tab inputRef={ref} className={cx(styles.tab, [tabIndex === 2 && styles.selectedTab])} onClick={() => setTabIndex(2)}>
            <span>{t('video.settings.share.embed')}</span>
          </Tab>
        </div>
        <div className={styles.closeBtn} onClick={onClose}>
          <Icon className={styles.icon} src="close" />
        </div>
      </ModalHeader>
      {tabIndex === 1 ? <ShareVia videoId={videoId} videoPassword={videoPassword} isSkipAuthToken={isSkipAuthToken} /> : null}
      {tabIndex === 2 ? (
        <Embed videoId={videoId} videoPassword={videoPassword} isSkipAuthToken={isSkipAuthToken} thumbnailURL={anonThumbnailUrl} />
      ) : null}
    </div>
  );
}

export default SharingModalContent;
